import React from 'react';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import { getFormList } from '../../../../service';

import { Button, Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td, Link, Divider, Box } from '@chakra-ui/react';
import { parseLinkPath } from '../../../../util';
import AdminLayout from '../../Layout';

type Props = {
};

function FormBuilderList({  }: Props) {

  const queryClient = new QueryClient();
  const { isLoading, error, data } = useQuery('getPage', () => getFormList());

  return (
    <AdminLayout>
    {
      !isLoading && (
        <Table variant='striped' colorScheme='teal'>
          <Thead>
            <Tr>
              <Th>ID</Th>
              <Th>제목</Th>
            </Tr>
          </Thead>
          <Tbody>
            {
              data.map((item:any, index:number) => (
                <Tr key={index}>
                  <Td>{item.id}</Td>
                  <Td><Link href={parseLinkPath(`/form-builder-edit?form_id=${item.id}`)}>{item.title}</Link></Td>
                </Tr>
              ))
            }
          </Tbody>
        </Table>
      )
    }
    <Box pt="5">
      <Button as="a" href={parseLinkPath('/form-builder-new')} size="md" colorScheme="dgr">양식 추가</Button>
    </Box>
    </AdminLayout>
  );
}

FormBuilderList.defaultProps = {
};

export default FormBuilderList;